export default __webpack_public_path__ + "static/media/Cloak of Insight.15354771.jpg";